import { Column } from "@faire/web--source/slate/Layout";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import styled from "styled-components";
export var NarrowContainer = styled(Column).withConfig({
    componentId: "sc-721d064d-0"
})([
    "width:100%;max-width:744px;",
    "{padding:0px;width:calc(100% - 36px);}",
    "{max-width:648px;}"
], responsiveMediaQueries.mobile, responsiveMediaQueries.tablet);
